import { connect } from 'react-redux';
import { addIntegrationRequest, updateIntegrationRequest } from '../actions';
import { ADMIN_EDITABLE_STATUSES, READ_ONLY_STATUSES } from '../consts';
import { getStatusForType } from '../utils';
import { getIntegrationRequests, getVisibleIntegrationRequests } from '../../selectors/partnerIntegration';
import { getAdminModeEnabled } from '../../selectors/user';
import IntegrationRequestForm from '../components/IntegrationRequestForm';

const isReadOnly = (status, adminMode) =>
    READ_ONLY_STATUSES.includes(status) && !(adminMode && ADMIN_EDITABLE_STATUSES.includes(status));

const mapStateToProps = (state, ownProps) => {
    const adminMode = getAdminModeEnabled(state);
    if (ownProps.requestId) {
        const allRequests = getIntegrationRequests(state);
        const request = allRequests.find(r => r.id === ownProps.requestId) || null;
        const readOnly = !!request && isReadOnly(request.status, adminMode);
        return { existingRequest: request, readOnly };
    }
    const requests = getVisibleIntegrationRequests(state);
    const { request, status } = getStatusForType(requests, ownProps.requestType);
    const readOnly = !!request && isReadOnly(status, adminMode);
    return { existingRequest: request, readOnly };
};

const mapDispatchToProps = dispatch => ({
    onAddRequest: request => dispatch(addIntegrationRequest(request)),
    onUpdateRequest: request => dispatch(updateIntegrationRequest(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationRequestForm);
